// extracted by mini-css-extract-plugin
module.exports = {"MaxContentWidth":"MaxContentWidth-module--MaxContentWidth--3u2hM","fullHeight":"MaxContentWidth-module--fullHeight--31Xh1"};